<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <slot name="header">
        <h1>Shortcuts</h1>
      </slot>
    </div>
    <div class="panel-body">
      <nav
        v-for="shortcutData in shortcutsData"
        :key="shortcutData.heading"
        :class="'shortcut-' + shortcutClassSuffix">
        <p> {{ shortcutData.heading }} </p>
        <ul v-for="datum in shortcutData.links" :key="datum.linkText">
          <li>
            <span>
              <template>Browse content in </template>
              <router-link
                :to="datum.routeParams"
                @click.native="notifyEvent(datum.routeParams.query)"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="`Browse ${shortcutClassSuffix} in ${datum.linkText}`">
                {{ datum.linkText }}
                <OpensInNewTabIcon />
              </router-link>
            </span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import OpensInNewTabIcon from '../OpensInNewTabIcon.vue';

export default {
  name: 'ShortcutsPanel',
  components: {
    OpensInNewTabIcon
  },
  props: {
    shortcutsData: {
      type: Array,
      default() {
        return []
      }
    },
    shortcutClassSuffix: {
      type: String,
      required: true,
      validator: function(val) {
        return !(/\s/g.test(val)); // make sure there is no whitespace
      }
    },
  },
  methods: {
    notifyEvent(payload) {
      this.$emit('clickedLink', payload)
    }
  },
}
</script>

<style lang="less" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}
.panel-body nav:not(:last-child) {
  margin-bottom: 24px;
}

</style>
